import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';

export interface InputTypeDataLossWarningModalProperties {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Transitions that reduce or reshape series data (we aggregate / average); warn before applying. */
export function needsInputTypeDataLossWarning(fromType: string, toType: string): boolean {
  if (fromType === toType) return false;
  const warnTargets: Record<string, string[]> = {
    raw: ['constant', 'constant_by_year', 'growth'],
    constant_by_year: ['constant', 'growth'],
  };
  return warnTargets[fromType]?.includes(toType) ?? false;
}

const InputTypeDataLossWarningModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: InputTypeDataLossWarningModalProperties) => (
  <Modal isOpen={isOpen} onClose={onCancel} isCentered>
    <ModalOverlay />
    <ModalContent pb={3} maxW='md' color='black'>
      <ModalHeader position='relative'>
        <Text variant='modal' size='subTitle' align='center'>
          Change input type?
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text variant='modal' size='modalContent' textAlign='center'>
          Are you sure? Changing this input type will replace your detailed values with a single
          average value. For example, 10, 20, 30 becomes 20. Your original values may be lost.
        </Text>
      </ModalBody>
      <ModalFooter pb='0' justifyContent='center'>
        <HStack spacing='5'>
          <Button variant='clear' size='auto' fontSize='xs' color='red.500' onClick={onCancel}>
            Cancel
          </Button>
          <Button variant='clear' size='auto' fontSize='xs' color='violet.900' onClick={onConfirm}>
            Confirm
          </Button>
        </HStack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);

export default InputTypeDataLossWarningModal;
